/**
 * Example: import { color, size } from '@scp/ui-shared/theme/variables'
 */
export { color } from './colors';
export { typography } from './typography';
export { size, breakPoint } from './sizes';
export { property, TRANSITION_TIMING_ARGS } from './properties';
export { zIndex } from './zIndexes';